import { DataCard } from "components/DataCardComponent/styles"
import { HiOutlineBell } from "react-icons/hi"

export interface IArchivedAndNewContainerProps {
  totalNumber: string
  archivedNumber: string
}
export const ArchivedAndNewContainer = ({ totalNumber, archivedNumber }: IArchivedAndNewContainerProps) => {
  return (
    <DataCard className='w-[493px] h-[100px] flex justify-between '>
      <div className="w-1/2 flex flex-col">
        <span className='text-darkGray text-[28px] font-semibold'>{totalNumber ||0}</span>
        <span className='text-base'>
          Notificações registradas
        </span>
      </div>
      <hr className="h-full mr-4 border-r bg-borderLine" />
      <div className="w-1/2 ">
        <div className='flex flex-col h-full justify-center'>
          <div className='items-center flex gap-1 '>
            <span className='text-darkGray text-base font-bold'>{totalNumber ? parseInt(totalNumber) - parseInt(archivedNumber): 0}</span>
            <span className='text-base'>
              Novas e Aceitas
            </span>
          </div>
          <div className='items-center flex gap-1 align-middle'>
            <span className='text-darkGray text-base font-bold'>{archivedNumber || 0 }</span>
            <span className='text-base'>
              Arquivadas
            </span>
          </div>
        </div>
      </div>
      <HiOutlineBell size={27}
        color='#F0B323'
      />
    </DataCard>
  )
}